/**
 * Last full Assets roster this session, shown at once when the Assets page is
 * opened again and refreshed in the background. Memory only: not kept across
 * reloads. Keyed by the signed-in user: sign-out does not reload the page, so a
 * copy from another user (possibly another organisation) is never returned.
 */
import { readSessionUserEmail } from '../auth/cognitoAuth';

let copy: { user: string; vehicles: unknown[]; timestamp?: string } | null = null;

/** The current user's copy, or null. */
export function readAssetsRosterSessionCopy<T>(): { vehicles: T[]; timestamp?: string } | null {
  const user = readSessionUserEmail();
  if (!copy || !user || copy.user !== user) return null;
  return { vehicles: copy.vehicles as T[], timestamp: copy.timestamp };
}

/** Keep the roster for the current user (nothing kept without a session). */
export function writeAssetsRosterSessionCopy(vehicles: unknown[], timestamp?: string): void {
  const user = readSessionUserEmail();
  copy = user ? { user, vehicles, timestamp } : null;
}

/** Drop the copy (sign-out, attributes saved). */
export function clearAssetsRosterSessionCopy(): void {
  copy = null;
}
